export function getCandidatImage(
  year: number | string,
  number: number | string,
  index: number,
  size: 's' | 'l' = 's'
): string | undefined {
  try {
    return require(`../images/candidats/${year}/${number}-${index}-${size}.jpg`)
  } catch {
    return undefined
  }
}
